"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgDeckchairs = function SvgDeckchairs(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m8.193 9.621 3.092-6.598m.045-.403L2.872 9.025c.561.31 1.2.532 1.92.664.994.181 2.089.181 3.284-.002l.147-.023.136.061c1.107.502 2.21.75 3.312.75 1.105 0 2.236-.25 3.396-.753l.128-.056.14.02c1.167.16 2.177.16 3.029.003.64-.118 1.314-.349 2.023-.692L11.33 2.619zm3.764 7.23-3.726-6.862m5.524 10.755c.682.63 1.244 1.447 1.689 2.45m-7.064.331 8.027-4.216M3.449 16.5h17v2h-17zm1 2h2v2h-2zm13 0h2v2h-2zM11.5 10v6.027",
    stroke: "#4D4D4D",
    fill: "none"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgDeckchairs);
var _default = exports["default"] = Memo;